import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';

import EllipsisMenu       from 'app/components/common/ellipsis-menu';
import Icon               from 'app/components/common/icon';
import Link               from 'app/components/common/link';
import Meta               from 'app/components/common/meta';
import Pagination         from 'app/components/common/pagination';
import ScrollTable        from 'app/components/common/scroll-table';
import CadminLayout       from 'app/components/company-admin/layout/';
import PageLoading        from 'app/components/layout/page-loading';
import FormsDuck          from 'app/ducks/company-admin/forms';
import UiFormsDuck        from 'app/ducks/company-admin/ui-forms';
import formsHelpers       from 'app/helpers/forms';
import paths              from 'app/paths';
import CadminSlx          from 'app/selectors/company-admin/';

class CadminPageFormsShow extends React.PureComponent {

  constructor(props) {
    super(props);
  }

  renderMain() {
    return <h2>hi</h2>;
  }

  render() {
    const {company} = this.props;
    if (!company) return <PageLoading />;

    return (
      <CadminLayout className="ca-forms" company={company} activeItem="forms">
        <Meta title={`SHOW FORM | Millie`} />
        <div className="ca-main-head">
          {/* <Link className="ca-main-head-back" href={paths.cadminCampaigns(company.slug)}><Icon.Caret direction="left" /> Back to Campaigns</Link> */}
          <h1 className="ca-main-head-h1">SHOW FORM</h1>
          <div className="ca-main-head-actions">
          </div>
        </div>
        {this.renderMain()}
      </CadminLayout>
    );
  }

}

const stateToProps = (state) => ({
  company: CadminSlx.company(state),
});
const dispatchToProps = (dispatch) => ({});

export default connect(stateToProps, dispatchToProps)(CadminPageFormsShow);
